import { axiosPost } from '../../axios/axios.js'

export const closeRequest = {
  methods: {
    closeRequest: function (objectId, props, loadingActivity, contextProps) {
      const bodyFormData = new FormData()
      bodyFormData.set('objectId', objectId)
      bodyFormData.set('props', JSON.stringify(props))

      loadingActivity && loadingActivity.startLoading('Закрытие заявки')

      return axiosPost({
        url: '/service/delta/requestBusinessProcess/BS17',
        data: bodyFormData,
        onSuccess: () => {
          loadingActivity && loadingActivity.stopLoading()

          this.$q.notify({
            type: 'positive',
            message: 'Заявка успешно закрыта',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          loadingActivity && loadingActivity.stopLoading()

          const yesNoAskError = response.errors && response.errors.find(err => err.code === 'yesNoAsk')
          if (yesNoAskError) {
            this.$d_ask({
              callback: (data) => {
                props.closeExternalVis = true
                return this.closeRequest(objectId, props, loadingActivity)
              },
              header: 'Закрыть заявку?',
              warning: yesNoAskError.message
            })
          } else {
            const supTaskClosureError = response.errors && response.errors.find(err => err.code === 'supTaskClosure')
            if (supTaskClosureError) {
              const supTaskClosureData = supTaskClosureError.data
              const closureInfo = supTaskClosureData.closureInfo
              const supTaskVersions = this.request.supTaskData.supTask
              const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[supTaskVersions.length - 1] || {}

              const warnings = []
              if (closureInfo.cancelled) {
                warnings.push('Текущий статус задачи ПТК АПТС: ' + closureInfo.statusName + '.')
              }
              if (supTaskClosureData.warnings) {
                warnings.push(...supTaskClosureData.warnings)
              }

              const buttons = []
              if (closureInfo.closureAvailable) {
                buttons.push({ key: 'close', name: 'Закрыть в Д2 и ПТК АПТС', color: 'green' })
                if (supTaskClosureData.skipClosureAvailable) { // M2.2
                  buttons.push({ key: 'skip', name: 'Закрыть в Д2 и не менять статус задачи ПТК АПТС ', color: 'blue' })
                } // else M2.1
              } else {
                warnings.push('Совместное закрытие заявки Д2 и задачи ПТК АПТС невозможно по причине:')
                if (closureInfo.cancelTimeoutExceeded) { // ~M2.3
                  warnings.push('Истек разрешенный срок изменений (30 дней).')
                }
                if (!closureInfo.requiredWorksDone) {
                  warnings.push('Не выполнены обязательные работы.')
                }
                if (!closureInfo.hasRequiredPhotos) {
                  warnings.push('Отсутствуют фотографии до/после выполнения работ.')
                }
                if (supTaskClosureData.skipClosureAvailable) {
                  buttons.push({ key: 'skip', name: 'Закрыть заявку Д2 без закрытия задачи ПТК АПТС', color: 'blue' })
                }
              }
              buttons.push({ key: 'cancel', name: 'Отмена', color: 'white', emitable: true, onEscape: true })

              return new Promise((resolve, reject) => {
                this.$d_ask({
                  callback: (data, action) => {
                    if (action === 'close' || action === 'skip') {
                      props.checkRequestCondition = false
                      props.closeExternalVis = action === 'close'
                      resolve(this.closeRequest(objectId, props, loadingActivity, { supTaskClosure: true }))
                    } else {
                      resolve('cancel')
                    }
                  },
                  header: 'Совместное закрытие заявки Д2 и задачи ПТК АПТС',
                  warning: warnings,
                  propsConfig: {
                    number: { type: 'text', label: 'Номер задачи ПТК АПТС', value: supTask.number, readonly: true },
                    address: { type: 'text', label: 'Адрес', value: supTask.address, readonly: true }
                  },
                  buttons: buttons
                })
              })
            } else {
              let message
              let caption
              if (response.code === 'timeout' && contextProps && contextProps.supTaskClosure) {
                message = 'Истек таймаут запроса закрытия задачи ПТК АПТС'
                caption = 'Повторите операцию, при повторной ошибке обратитесь к администратору.'
              } else {
                message = 'Ошибка закрытия заявки'
                caption = response.message
              }

              this.$q.notify({
                type: 'negative',
                message: message,
                caption: caption,
                timeout: 8000,
                progress: true
              })
            }
          }
        }
      })
    }
  }
}
